import { z } from "zod";
import { TIPOS_MOVIMENTACAO_MANUAL } from "../dominio";
import { id } from "./comuns";

/**
 * Movimentação lançada pelo ADMIN. Em ENTRADA e PERDA a quantidade é informada positiva
 * (o servidor aplica o sinal); em AJUSTE ela já vem com sinal (+ sobra, − falta).
 */
export const movimentacaoCriarSchema = z
  .object({
    produtoId: id,
    tipo: z.enum(TIPOS_MOVIMENTACAO_MANUAL),
    quantidade: z.number().int().min(-100_000).max(100_000),
    motivo: z.string().trim().max(300).optional(),
  })
  .superRefine((v, ctx) => {
    if (v.tipo === "AJUSTE" ? v.quantidade === 0 : v.quantidade <= 0) {
      ctx.addIssue({
        code: "custom",
        path: ["quantidade"],
        message: v.tipo === "AJUSTE" ? "O ajuste não pode ser zero" : "A quantidade precisa ser maior que zero",
      });
    }
    if (v.tipo !== "ENTRADA" && !v.motivo) {
      ctx.addIssue({ code: "custom", path: ["motivo"], message: "Informe o motivo" });
    }
  });
export type MovimentacaoCriarEntrada = z.input<typeof movimentacaoCriarSchema>;
